<script>
  import router from '../../../lib/router';
  import { onMount } from 'svelte';
  import { MDCDialog } from '@material/dialog';
  import NumberFieldWithButtons from '../../../lib/components/NumberFieldWithButtons.svelte';

  import { TS } from '../../../config/translation-keys.js';
  import { t9n } from '../../../lib/translate.js';

  export let order;
  export let order_uuid;
  export let has_inited;
  export let tooltip;

  let dialog;
  let units;
  let label;

  const init_share = () => {
    if(order.product.based_on === 'product_based_hours') label = t9n(TS.ADD_HOURS);
    if(order.product.based_on === 'product_based_days') label = t9n(TS.ADD_DAYS);
    if(order.product.based_on === 'product_based_months') label = t9n(TS.ADD_MONTHS);
    if(order.product.based_on === 'product_based_units') label = t9n(TS.ADD_UNITS);
    if(order.product.based_on === 'product_based_price') label = t9n(TS.ADD_PRICE);
    dialog = new MDCDialog(document.getElementById(`unit-dialog`));
  };

  const open_copy = () => {
    close();

    router.navigate(
      `/order-new?state=copy&id=${order_uuid}&units=${units}&no_payment=${order.no_payment.toString()}`
    );
  };

  export const open = () => dialog.open();

  export const close = () => dialog.close();

  onMount(init_share);
</script>

<div id="unit-dialog" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content">

      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class="mdc-dialog__title" id="my-dialog-title">
        {label}
      </h2>

      <div
        class="tooltip-default"
        style="margin: 18px;">
        <div
          id="tooltip_def"
          class="tooltip-text tooltip-top"
          style="background-color: var(--mdc-theme-secondary); color: rgb(255,
          255, 255);">
          {tooltip}
        </div>
      </div>

      <div class="mdc-dialog__content" id="my-dialog-content">
        <NumberFieldWithButtons
          id="duration"
          type="text"
          label={t9n(order.product.based_on)}
          name="duration"
          bind:value={units}
          width="155px"
          margin_top="15px" />
      </div>

      <footer class="mdc-dialog__actions">
        <!--                {#each buttons as button}-->
        <!--                    <button class="mdc-button mdc-button&#45;&#45;raised {button.classes}"-->
        <!--                            tabindex="0"-->
        <!--                            on:click|preventDefault|stopPropagation={button.action}>-->
        <!--                        {button.label}-->
        <!--                    </button>-->
        <!--                {/each}-->

        <button
          id="add_unit_close"
          on:click={() => close()}
          class="btn-close mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {t9n(TS.ORDERER_TEAMS_CLOSE_LABEL)}
        </button>

        {#if units === null || units === 0}
          <button
            on:click={() => open_copy()}
            disabled
            class="btn-close mdc-button mdc-button--unelevated">
            <span class="mdc-button__ripple" />
            {t9n(TS.ORDERER_TEAMS_ADD_LABEL)}
          </button>
        {:else}
          <button
            on:click={() => open_copy()}
            class="btn-close mdc-button mdc-button--unelevated">
            <span class="mdc-button__ripple" />
            {t9n(TS.ORDERER_TEAMS_ADD_LABEL)}
          </button>
        {/if}
      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<style>
  #share-dialog .mdc-dialog__surface {
    max-width: 450px;
    width: 450px;
  }

  #unit-dialog .mdc-dialog__content {
    margin: auto;
    margin-top: -42px;
  }

  #share-dialog .material-icons {
    margin-left: -5px;
    margin-right: 5px;
  }

  #share-dialog input {
    position: absolute;
    top: -1000px;
    left: -1000px;
  }

  .btn-close {
    margin-left: 5px;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    display: block;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 30px;
    left: -88px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }

  .mdc-dialog__surface {
    width: 400px;
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    #share-dialog .mdc-dialog__surface {
      max-width: min-content;
      width: 100%;
    }
  }

  a:link {
    text-decoration: none;
  }
</style>
